import {CanActivateFn} from '@angular/router';
import {inject} from "@angular/core";
import {CommonService} from "../service/common.service";
import {NavController} from "@ionic/angular";
import {NavigationService} from "../service/navigation.service";

export const profileTypeGuard: CanActivateFn = (route, state) => {

  const commonService = inject(CommonService);
  const navigationService = inject(NavigationService);

  if(commonService.profileType){
    if(commonService.profileType === 'turista' && route.data['redirectToTouristSection']){
      navigationService.goRoot(['/tourist-tabs']);
      return true;
    } else {
      return true;
    }
  } else {

    //Se c'è un link verso i tabs, rimappo sui tourist-tabs
    const url = state.url?.includes('tabs/') ? state.url.replace('tabs/','tourist-tabs/'): state.url;

    navigationService.navigationAfterLogin = [url];
    navigationService.goRoot(['/welcome']);
    return false;
  }

};
